'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by li on 2016/4/11.
                    */

// import ReactPaginate from 'react-paginate';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Paginate = require('../Paginate/Paginate');

var _Paginate2 = _interopRequireDefault(_Paginate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HomePagingBar = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HomePagingBar, _Component);

  function HomePagingBar() {
    (0, _classCallCheck3.default)(this, HomePagingBar);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(HomePagingBar).apply(this, arguments));
  }

  (0, _createClass3.default)(HomePagingBar, [{
    key: 'handlePageClick',
    value: function handlePageClick(object) {
      var onPageItemClick = this.props.onPageItemClick;

      if (onPageItemClick) {
        onPageItemClick(object.selected);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./HomePagingBar.scss');
      var _props = this.props;
      var totalPageNumber = _props.totalPageNumber;
      var selected = _props.selected;

      var width = 200;
      if (totalPageNumber <= 11) {
        // if (totalPageNumber <= 8) {
        // width = 200 + totalPageNumber * 35;
        width = 95 + totalPageNumber * 45;
      } else {
        width = 590;
      }
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'div',
          { style: { width: width, height: 43, margin: '0 auto' } },
          _react2.default.createElement(_Paginate2.default, { previousLabel: _react2.default.createElement('span', { className: styles.triangle_border_left }),
            nextLabel: _react2.default.createElement('span', { className: styles.triangle_border_right }),
            breakLabel: _react2.default.createElement(
              'span',
              null,
              '...'
            ),
            forceSelected: selected,
            pageNum: totalPageNumber,
            marginPagesDisplayed: 2,
            pageRangeDisplayed: 5,
            clickCallback: this.handlePageClick.bind(this),
            containerClassName: styles.pagination,
            subContainerClassName: "pages pagination",
            activeClassName: styles.active })
        )
      );
    }
  }]);
  return HomePagingBar;
}(_react.Component), _class.propTypes = {
  totalPageNumber: _react.PropTypes.number.isRequired,
  onPageItemClick: _react.PropTypes.func,
  selected: _react.PropTypes.number
}, _temp);

// <ReactPaginate previousLabel={<span className={styles.triangle_border_left}></span>}
//               nextLabel={<span className={styles.triangle_border_right}></span>}
//               breakLabel={<span>...</span>}
//               pageNum={totalPageNumber}
//               marginPagesDisplayed={2}
//               pageRangeDisplayed={5}
//               clickCallback={this.handlePageClick.bind(this)}
//               containerClassName={styles.pagination}
//               subContainerClassName={"pages pagination"}
//               activeClassName={styles.active}/>

exports.default = HomePagingBar;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/HomePagingBar/HomePagingBar.js
 ** module id = 602
 ** module chunks = 0
 **/